import WithRender from "../../templates/base/quantityField.html";
import { mapGetters, mapActions } from "vuex";
import { i18n } from "../../i18n.js";

export default WithRender({
  computed: {
    ...mapGetters(["getQuantityField"]),
    name: () => {
      return "Quantity:";
    },
    quantity: {
      get: function () {
        return this.getQuantityField;
      },
      set: function (newValue) {
        this.setQuantityField(newValue);
      }
    }
  },
  methods: {
    ...mapActions(["setQuantityField"]),
    onQuantity: function (event) {
      event.preventDefault();
      var isNum = /^\d+$/.test(event.target.value);
      if (!isNum) {
        this.$swal({
          text: i18n.t("Please enter a valid number !"),
          icon: "warning"
        });
        this.quantity = 1;
        return;
      }

      var intQty = parseInt(event.target.value);

      if (intQty == 0) {
        this.$swal({
          text: i18n.t("Quantity should be bigger than 0"),
          icon: "warning"
        });
        this.quantity = 1;
        return;
      }
    }
  }
});
